import partial from 'lodash/partial';

import { Editor } from '@lumapps/wrex/slate';
import { createPlugin, CreatePluginEditor } from '@lumapps/wrex/slate/plugin';
import { normalizeLiftToRootNode } from '@lumapps/wrex/slate/utils/normalizeLiftToRootNode';
import { selectElementOnDelete } from '@lumapps/wrex/slate/utils/selectElementOnDelete';
import { WrexEditor } from '@lumapps/wrex/types';

import { EditableEmbeddedVideo } from '../components/editableBlocks/EditableEmbeddedVideo';
import { EmbeddedVideoEditor } from '../types';
import { insertEmbeddedVideo } from '../utils/insertEmbeddedVideo';
import { isEmbeddedVideo } from '../utils/isEmbeddedVideo';

const createPluginEditor = (): CreatePluginEditor<EmbeddedVideoEditor, WrexEditor<EmbeddedVideoEditor>> => (editor) => {
    const { isVoid, normalizeNode, deleteBackward, deleteForward } = editor;

    return {
        normalizeNode([node, path]) {
            const pathRef = Editor.pathRef(editor, path);
            normalizeLiftToRootNode(editor, [node, path], isEmbeddedVideo);
            const changedPath = pathRef.unref();
            if (changedPath) {
                normalizeNode([node, changedPath]);
            }
        },

        isVoid: (element) => isEmbeddedVideo(element) || isVoid(element),

        deleteBackward(unit) {
            if (unit === 'character' && selectElementOnDelete(editor, false, isEmbeddedVideo)) {
                return;
            }
            deleteBackward(unit);
        },

        deleteForward(unit) {
            if (unit === 'character' && selectElementOnDelete(editor, true, isEmbeddedVideo)) {
                return;
            }
            deleteForward(unit);
        },

        insertEmbeddedVideo: partial(insertEmbeddedVideo, editor),
    };
};
export const withEmbeddedVideo = () =>
    createPlugin({
        createPluginEditor: createPluginEditor(),
        elements: [EditableEmbeddedVideo],
    });
